/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react'
import { createPaginationArray } from 'lib/functions'
import styles from './Pagination.module.scss'

const Pagination = ({ currentPage, totalPages, getPageLink }) => {
  const [isPC, setIsPC] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsPC(window.innerWidth >= 880)
    }

    // 初回レンダリング時のチェック
    handleResize()
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const paginationArray = createPaginationArray(currentPage, totalPages, isPC)

  return (
    <div className={styles.pagination}>
      <a
        className={`${styles.page_no} ${currentPage === 1 ? styles.disabled : ''}`}
        href={currentPage > 1 ? getPageLink(currentPage - 1) : undefined}
      >
        <img
          src={currentPage === 1 ? '/images/icons/direction_gray_pager.svg' : '/images/icons/direction_block.svg'}
          className={currentPage === 1 ? styles.arrow_disabled : styles.page_no_prev}
          alt="Previous"
        />
      </a>

      {paginationArray.map((item, index) =>
        item === '...' ? (
          <span className={styles.elipsis} key={`${item}-${index}`}>
            {item}
          </span>
        ) : (
          <a
            key={`${item}-${index}`}
            href={getPageLink(item)}
            className={`${styles.page_no} ${currentPage === item ? styles.page_no_active : ''}`}
          >
            {item}
          </a>
        ),
      )}

      <a
        className={`${styles.page_no} ${currentPage === totalPages ? styles.disabled : ''}`}
        href={currentPage < totalPages ? getPageLink(currentPage + 1) : undefined}
      >
        <img
          src={
            currentPage === totalPages ? '/images/icons/direction_gray_pager.svg' : '/images/icons/direction_block.svg'
          }
          className={currentPage === totalPages ? styles.arrow_disabled_next : styles.page_no_next}
          alt="Next"
        />
      </a>
    </div>
  )
}

export default Pagination
